var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C15.5189 0 20 4.4751 20 10C20 15.5189 15.5249 20 10 20C4.4811 20 0 15.5249 0 10C0 4.4811 4.4751 0 10 0ZM8.71026 8.0144H10.7618V9.06419H10.7918C11.0798 8.54829 11.7756 8.0144 12.8194 8.0144C14.985 8.0144 15.3869 9.36413 15.3869 11.1158V14.6911H13.2454V11.5237C13.2454 10.7678 13.2274 9.79604 12.1296 9.79604C11.0138 9.79604 10.8458 10.6179 10.8458 11.4697V14.6911H8.70426V8.0144H8.71026ZM7.22855 6.16077C7.22855 6.77265 6.73065 7.27654 6.11278 7.27654C5.5009 7.27654 4.997 6.77864 4.997 6.16077C4.997 5.54889 5.4949 5.04499 6.11278 5.04499C6.72465 5.04499 7.22855 5.54289 7.22855 6.16077ZM5.003 8.0144H7.22855V14.6911H5.003V8.0144Z",
    fill: "#002106"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b60148297efef7a4b90036c68c19fe5a.svg";
export { ForwardRef as ReactComponent };